import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';

import App from '@/App';

import './index.css';
import {DeviceProvider} from './providers/DeviceContext';
import {ResponsiveProvider} from './providers/ResponsiveContext';

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <StrictMode>
    <ResponsiveProvider>
      <BrowserRouter basename={import.meta.env.VITE_PUBLIC_URL || ''}>
        <App />
      </BrowserRouter>
    </ResponsiveProvider>
  </StrictMode>
);
